import React, { FunctionComponent, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { selectIsPiPActive, togglePiPActiveAction } from '../../../../settings';
import { SettingsTumbler } from './settings-tumbler';

export const PiPActiveTumbler: FunctionComponent = () => {
    const { togglePiPActive } = useActions({ togglePiPActive: togglePiPActiveAction });
    const isPiPActive = useSelector(selectIsPiPActive);

    const onChange = useCallback(() => togglePiPActive(), [togglePiPActive]);

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'pip-active-tumbler-label')}
            checked={isPiPActive}
            onChange={onChange}
            testId="pip-active-tumbler"
        />
    );
};
